import React from "react";

const steps = ["Register", "Invite", "Hierarchy"];

const Stepper = ({ currentStep }) => {
    return (
        <div className="flex items-center gap-6">
            {steps.map((label, index) => {
                const stepNumber = index + 1;
                const isActive = currentStep === stepNumber;
                const isCompleted = currentStep > stepNumber;

                return (
                    <div
                        key={label}
                        className="flex items-center gap-2 text-sm font-medium"
                    >
                        <span
                            className={`flex items-center justify-center w-6 h-6 rounded-full border text-xs
                ${isActive
                                    ? "bg-black text-white border-black"
                                    : isCompleted
                                        ? "bg-gray-400 text-white border-gray-400"
                                        : "bg-gray-200 text-gray-500 border-gray-300"}
              `}
                        >
                            {stepNumber}
                        </span>
                        <span
                            className={`${isActive
                                ? "text-black font-semibold"
                                : "text-gray-500"
                                }`}
                        >
                            {label}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default Stepper;
